import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';  // ✅ 이 라인 그대로 유지
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
